// v1.1.0 · Web pública rediseñada (reemplaza la composición anterior de la landing en App.js)
// v1.2.0 · + garantías del contrato, preguntas frecuentes y barra fija de contacto en móvil
// v1.3.0 · Rediseño «60 días en una línea de producción» (hero con regla interactiva, proyectos en pestañas)
// v1.4.0 · Holograma 3D del día 60, fondo animado sutil, 6 proyectos, banderas, logo más grande
// v1.5.0 · Gris suave en lugar de blanco, transición entre secciones y 5 pantallas animadas por proyecto
// v1.6.0 · Titular animado (tachado, subrayado y conteo del 60) y formulario con selección múltiple y «Otra»
// v1.21.0 · Portada inmersiva por servicios (SiteImmersive) en lugar del hero de 60 días
import React, { useEffect, useRef } from 'react';
import './site.css';
import SiteHeader from './SiteHeader';
import SiteImmersive from './SiteImmersive';   // v1.21.0
import SiteCapabilities from './SiteCapabilities';
import SiteProjects from './SiteProjects';
import SiteMethod from './SiteMethod';
import SiteGuarantees from './SiteGuarantees';
import SiteFaq from './SiteFaq';
import SiteContact from './SiteContact';
import SiteStickyCta from './SiteStickyCta';
import SiteFooter from './SiteFooter';

// v1.5.0 · Transición entre secciones: los bloques [data-reveal] entran al aparecer en pantalla y una línea de
//           escaneo recorre cada sección [data-scan]. Sin JavaScript o con «reducir movimiento», todo queda visible.
function useReveal(ref) {
  useEffect(() => {
    const root = ref.current;
    if (!root || !('IntersectionObserver' in window)) return undefined;
    if (window.matchMedia?.('(prefers-reduced-motion: reduce)').matches) return undefined;
    root.classList.add('reveal-ready');
    const els = root.querySelectorAll('[data-reveal], [data-scan]');
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (!e.isIntersecting) return;
        const el = e.target;
        if (el.hasAttribute('data-scan')) el.style.setProperty('--scan-h', `${el.offsetHeight}px`);
        el.setAttribute('data-shown', '');
        io.unobserve(el);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    els.forEach((el) => io.observe(el));
    return () => { io.disconnect(); root.classList.remove('reveal-ready'); };
  }, [ref]);
}

export default function SiteLanding() {
  const ref = useRef(null);
  useReveal(ref);
  return (
    <div ref={ref} className="site min-h-screen" data-testid="site-landing">
      <a href="#contenido" className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[60] focus:rounded-lg focus:bg-white focus:px-4 focus:py-2">
        Saltar al contenido
      </a>
      <SiteHeader />
      <main id="contenido">
        <SiteImmersive />
        <SiteCapabilities />
        <SiteProjects />
        <SiteMethod />
        <SiteGuarantees />
        <SiteFaq />
        <SiteContact />
      </main>
      <SiteFooter />
      <SiteStickyCta />
    </div>
  );
}
